import { api } from './api';

export const cartApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCart: builder.mutation({
      query: () => {
        return {
          url: 'getCart',
        };
      },
    }),

    addToCart: builder.mutation({
      query: (itemData) => {
        return {
          url: 'addToCart',
          method: 'POST',
          body: itemData,
        };
      },
    }),

    removeFromCart: builder.mutation({
      query: ({ id }) => {
        return {
          url: 'removeFromCart',
          method: 'POST',
          body: {
            id,
          },
        };
      },
    }),

    clearCart: builder.mutation({
      query: ({ isInventory }) => {
        return {
          url: 'clearCart',
          method: 'POST',
          body: {
            isInventory,
          },
        };
      },
    }),
  }),
});

export const {
  useGetCartMutation,
  useAddToCartMutation,
  useRemoveFromCartMutation,
  useClearCartMutation,
} = cartApi;
